<template>
  <div id="signature-pad-template">
    <div class="text-sm-left text-bold"
         style="display: flex;">{{signHintText1}} <base-note no-num
                 style="flex: 2;"
                 >{{signHintText2}}</base-note>
        <v-btn small outline color="black"  @click="clearSignature(true)"  style="float:right">清除</v-btn>
    </div>
    <div id="signature-pad"
         class="signature-pad">
      <div class="signature-pad__body">
        <canvas name="signature"
                ref="canvas"
                v-on:mousedown="triggerSign"
                v-on:touchstart="triggerSign"
                width="900"
                height="350"></canvas>
      </div>
    </div>
  </div>
</template>
<script>
import SignaturePad from 'signature_pad'

export default {
  name: 'signature',
  props: ['signatureFor', 'value', 'cfgData'],
  data: () => ({
    pad: null,
    signHint1: '請在此處簽名:',
    signHint2: '請親自簽正楷全名',
    signature: null,
    hadSigned: false
  }),
  mounted () {
    // this.pad = new SignaturePad(this.$refs.canvas)
    //fix: Issue #87784 ，調整簽名時字體粗細大小
    this.pad = new SignaturePad(this.$refs.canvas, { minWidth: 1, maxWidth: 6 })
    this.pad.name = this.signatureFor
  },
  methods: {
    triggerSign () {
      this.hadSigned = true
    },
    saveSignature () {
      let signValue = ''
      if (this.hadSigned) {
        this.signature = this.pad.toDataURL()
        signValue = this.signature
      }
      this.$emit('signed', signValue) // 觸發父組件
    },
    clearSignature (log) {
      this.pad.clear()
      this.hadSigned = false
      this.signature = null
      this.$emit('signed', null)
      if (log) {
        this.$store.dispatch('common/postUserAccessLog', ({ progClassName: 'signature_clearSign', methodName: '清除簽名' }))
      }
    },
    resizeCanvas () {
      var ratio = Math.max(window.devicePixelRatio || 1, 1)
      this.$refs.canvas.width = this.$refs.canvas.offsetWidth * ratio
      this.$refs.canvas.height = this.$refs.canvas.offsetHeight * ratio
      this.$refs.canvas.getContext('2d').scale(ratio, ratio)
    }
  },
  watch: {
    value: function (newValue) {
      if (newValue === '') {
        this.clearSignature(false)
      } else if (newValue) {
        // this.pad.fromDataURL()
      }
    }
  },
  computed: {
    signHintText1 () {
      if (this.cfgData.signHint1) {
        return this.cfgData.signHint1
      } else {
        return this.signHint1
      }
    },
    signHintText2 () {
      if (this.cfgData.signHint2) {
        return this.cfgData.signHint2
      } else {
        return this.signHint2
      }
    }
  },
  beforeDestroy () {
    if (this.pad) {
      this.clearSignature(false)
    }
  }
}
</script>
<style lang="stylus" scoped>
canvas {
  height: 350px;
  margin: 10px 10px 30px 10px;
  border: 2px solid #b5aeae;
}
.v-btn--small {
    height: 32px;
}
#signature-pad-template {
  user-select: none;
}
</style>
